<section class="content-section">
  <h2 class="section-title"><mat-icon>auto_awesome</mat-icon> Created by Agent</h2>

  <div class="content-grid">
    @for (section of sections; track section.type) {
      <div class="content-card" [ngClass]="'card-' + section.type">
        <div class="content-card-header">
          <mat-icon>{{ section.icon }}</mat-icon>
          <span class="content-card-title">{{ section.label }}</span>
          <span class="content-count">{{ section.items.length }}</span>
        </div>

        <div class="content-items">
          @for (item of section.items; track item.id) {
            <div class="content-item" matTooltip="Open {{ item.title }}">
              <span class="content-item-title">{{ item.title }}</span>
              <span class="content-item-date">{{ item.createdAt | date: 'MMM d' }}</span>
            </div>
          } @empty {
            <div class="content-empty">
              <mat-icon>hourglass_empty</mat-icon>
              <span>Nothing yet</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</section>
